const detectMobile = (): boolean => {
  // eslint-disable-next-line
  const ua = navigator.userAgent || navigator.vendor;
  if (/android/i.test(ua)) {
    // console.log('android');
    return true;
  }
  // eslint-disable-next-line
  if (/iPad|iPhone|iPod/.test(ua)) {
    // console.log('IOS');
    return true;
  }
  return false;
};

export default detectMobile;
